import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import AppSwitcher from "../appswitcher/AppSwitcher";
import Logo from "../../config/Logo";
import { useLocation, useHistory } from "react-router-dom";
import { useMediaQuery, useTheme } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const ElevationScroll = (props) => {
  const { children, window, iFrame } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger || iFrame ? 4 : 0,
    color: trigger || iFrame ? "secondary" : "transparent",
  });
};

let wpbar = document.getElementsByClassName("admin-bar").length > 0;

function TopBar({ openDrawer }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const topBarStyle = {};
  const iFrame =
    location.pathname === "/open" &&
    location.search &&
    location.search.split("?")?.[1];

  if (wpbar) topBarStyle["top"] = 32;
  if (isMobile) topBarStyle["position"] = "static";

  return (
    <div className={classes.root}>
      <ElevationScroll iFrame={iFrame}>
        <AppBar style={topBarStyle} id="appBar">
          <Toolbar>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={openDrawer}
            >
              <MenuIcon />
            </IconButton>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => history.push("/")}
            >
              <Logo size={40} />
            </div>
            <Typography
              variant="h6"
              onClick={() => history.push("/")}
              style={{ cursor: "pointer", marginLeft: 20 }}
            >
              {window.AppInfo.siteName}
            </Typography>
            <div className={classes.title} />
            {iFrame && <AppSwitcher />}
          </Toolbar>
        </AppBar>
      </ElevationScroll>
    </div>
  );
}
export default TopBar;
